import React, { useContext, useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import css from "./Today.module.css";
import { UserContext } from "../../Context/UserContext";
import { Head } from "../../Utils/Head";
import { terActs0, terActs1 } from "../../Utils/terActs";
import { updateUserFirebase } from "../../Utils/firebaseUser";

export const Today = () => {
  const { userData, setUserData } = useContext(UserContext);
  const graph = useRef(null);
  const [terActsList, setTerActsList] = useState("");
  const [isHover, setIsHover] = useState(false);
  const [actsToday, setActsToday] = useState([]);
  const [mood, setMood] = useState(false);
  const [errorDone, setErrorDone] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    setTerActsList(terActs0);
    userData &&
      userData.journey &&
      userData.journey.level &&
      userData.journey.level !== 0 &&
      setTerActsList(terActs1);
  }, [userData, terActsList]);

  useEffect(() => {
    userData &&
      userData.diary &&
      userData.diary[dayjs().format("YYMMDD")] &&
      setActsToday([
        ...userData.diary[dayjs().format("YYMMDD")].filter((a) => !a.done),
      ]);
  }, [userData]);

  function showCicle() {
    const ciclegraph = graph.current;
    const circleElements = ciclegraph.childNodes;

    let angle = 360 - 90;
    let dangle = 360 / circleElements.length;

    for (let i = 0; i < circleElements.length; i++) {
      let circle = circleElements[i];
      angle += dangle;
      circle.style.transform = `rotate(${angle}deg) translate(${
        ciclegraph.clientWidth / 2
      }px) rotate(-${angle}deg)`;
    }
  }

  const handleOnMouseOver = (act) => {
    setIsHover(act);
  };

  const handleMouseOut = () => {
    setIsHover(false);
  };

  function handleValidationDone(a) {
    let formIsValid = true;
    if (!mood) {
      formIsValid = false;
      setErrorDone(a.id);
    } else if (mood && mood.slice(1) !== a.id) {
      formIsValid = false;
      setErrorDone(a.id);
    } else {
      setErrorDone("");
    }
    return formIsValid;
  }

  function handleActDone(a) {
    let updatedList = [...userData.diary[a.date]];

    updatedList.forEach((element) => {
      if (element.id === a.id) {
        element.mood = mood[0];
        element.done = true;
      }
    });
    userData.diary[a.date] = [...updatedList];

    a.date === dayjs().format("YYMMDD") &&
      setActsToday(updatedList.filter((a) => !a.done));

    setUserData(userData);
    updateUserFirebase(userData);
  }

  if (userData && userData.member) {
    return (
      <div className={css.container}>
        <Head title="Today" description={"User - Mairini"} />
        <section className={css.main}>
          <div
            className={css.ciclegraph}
            onClick={() => navigate("/listeningpractice")}
          >
            <div
              className={css.ciclegraphInner}
              onClick={() => navigate("/listeningpractice")}
            >
              <h1>Prática de hoje</h1>
              {/* <p>
                Sequência de práticas:{" "}
                {userData.journey.sequence ? userData.journey.sequence : 0}
              </p> */}
            </div>
          </div>

          <div className={css.sectionTodayDiary}>
            <h1>Ações de hoje</h1>
            {actsToday[0] &&
              actsToday.map((a, i) => (
                <div className={css.card} key={i}>
                  <h4>{a.act}</h4>
                  <p>{a.value}</p>
                  <div className={css.cardMood}>
                    <p>Como foi a atividade?</p>
                    {mood === 1 + a.id ? (
                      <i
                        className={`material-icons materialIcons ${css.cardMoodActive}`}
                        onClick={() => setMood(false)}
                      >
                        mood_bad
                      </i>
                    ) : (
                      <i
                        className={`material-icons ${css.cardUserIcon}`}
                        onClick={() => setMood(1 + a.id)}
                      >
                        mood_bad
                      </i>
                    )}

                    {mood === 2 + a.id ? (
                      <i
                        className={`material-icons ${css.cardMoodActive}`}
                        onClick={() => setMood(false)}
                      >
                        sentiment_very_dissatisfied
                      </i>
                    ) : (
                      <i
                        className={`material-icons ${css.cardUserIcon}`}
                        onClick={() => setMood(2 + a.id)}
                      >
                        sentiment_very_dissatisfied
                      </i>
                    )}
                    {mood === 3 + a.id ? (
                      <i
                        className={`material-icons ${css.cardMoodActive}`}
                        onClick={() => setMood(false)}
                      >
                        sentiment_satisfied
                      </i>
                    ) : (
                      <i
                        className={`material-icons ${css.cardUserIcon}`}
                        onClick={() => setMood(3 + a.id)}
                      >
                        sentiment_satisfied
                      </i>
                    )}
                    {mood === 4 + a.id ? (
                      <i
                        className={`material-icons ${css.cardMoodActive}`}
                        onClick={() => setMood(false)}
                      >
                        sentiment_satisfied_alt
                      </i>
                    ) : (
                      <i
                        className={`material-icons ${css.cardUserIcon}`}
                        onClick={() => setMood(4 + a.id)}
                      >
                        sentiment_satisfied_alt
                      </i>
                    )}
                    {mood === 5 + a.id ? (
                      <i
                        className={`material-icons ${css.cardMoodActive}`}
                        onClick={() => setMood(false)}
                      >
                        sentiment_very_satisfied
                      </i>
                    ) : (
                      <i
                        className={`material-icons ${css.cardUserIcon}`}
                        onClick={() => setMood(5 + a.id)}
                      >
                        sentiment_very_satisfied
                      </i>
                    )}
                  </div>
                  {errorDone === a.id && (
                    <p className={css.error}>
                      É preciso avaliar a atividade antes de concluí-la
                    </p>
                  )}
                  {mood ? (
                    <button
                      className="greenButton"
                      onClick={() => handleActDone(a)}
                    >
                      Concluída
                    </button>
                  ) : (
                    <button className={css.buttonDisabled}>Concluída</button>
                  )}
                </div>
              ))}
          </div>
        </section>

        {/* {userData.member && (
          <section>
            <h1>Cards</h1>
            {terActsList.map((act, i) =>
              userData.journey && i <= userData.journey.lesson ? (
                <div
                  key={act.slug}
                  className={`${css.cardStart} ${css.cardStartActive}`}
                  onClick={() => navigate(`/teract/${act.slug}`)}
                >
                  <i className={`material-icons`}>{act.icon}</i>
                  <h4>{act.title}</h4>
                </div>
              ) : (
                <div key={act.slug} className={`${css.cardStart}`}>
                  <i className={`material-icons`}>{act.icon}</i>
                  <h4>{act.title}</h4>
                </div>
              )
            )}
          </section>
        )} */}
      </div>
    );
  } else if (userData && !userData.member && terActsList) {
    return (
      <div className={css.container}>
        <Head title="Today" description={"User - Mairini"} />
        <section className={css.main}>
          {userData.member && (
            <>
              <p>
                Sequência:{" "}
                {userData.journey.sequence ? userData.journey.sequence : 0}
              </p>
              <button
                className="orangeButton"
                onClick={() => navigate("/listeningpractice")}
              >
                Fazer uma prática
              </button>
            </>
          )}
          {userData.member ? (
            <p>
              Atualmente você está no nível {terActsList === terActs0 && `0`}{" "}
              {terActsList === terActs1 && `1`}
            </p>
          ) : (
            <p>Agende um atendimento para ter acesso a todos os recursos</p>
          )}
          <p>
            {terActsList === terActs0 &&
              `Aprenda sobre você e como montar sua jornada pessoal`}
          </p>
          {isHover ? (
            <div
              className={css.innerCircleActive}
              onMouseOver={() =>
                handleOnMouseOver(
                  userData.journey && terActsList[userData.journey.lesson]
                    ? terActsList[userData.journey.lesson]
                    : terActsList[0]
                )
              }
              onMouseOut={handleMouseOut}
              onClick={() =>
                navigate(
                  `/teract/${
                    userData.journey && terActsList[userData.journey.lesson]
                      ? terActsList[userData.journey.lesson].slug
                      : terActsList[0].slug
                  }`
                )
              }
            >
              <p>{isHover.levelName}</p>
              <h1>{isHover.title}</h1>
            </div>
          ) : (
            <div
              className={css.innerCircle}
              onClick={() =>
                navigate(
                  `/teract/${
                    userData.journey && terActsList[userData.journey.lesson]
                      ? terActsList[userData.journey.lesson].slug
                      : terActsList[0].slug
                  }`
                )
              }
            >
              <>
                <p>
                  {userData.journey && terActsList[userData.journey.lesson]
                    ? terActsList[userData.journey.lesson].levelName
                    : terActsList[0].levelName}
                </p>
                <h1>
                  {userData.journey && terActsList[userData.journey.lesson]
                    ? terActsList[userData.journey.lesson].title
                    : terActsList[0].title}
                </h1>
              </>
            </div>
          )}
          <div
            className={isHover ? css.ciclegraphHover : css.ciclegraph}
            ref={graph}
            onMouseOver={() =>
              handleOnMouseOver(
                userData.journey && terActsList[userData.journey.lesson]
                  ? terActsList[userData.journey.lesson]
                  : terActsList[0]
              )
            }
            onMouseOut={handleMouseOut}
            onClick={() =>
              navigate(
                `/teract/${
                  userData.journey && terActsList[userData.journey.lesson]
                    ? terActsList[userData.journey.lesson].slug
                    : terActsList[0].slug
                }`
              )
            }
          >
            {graph.current && showCicle()}
            {terActsList.map((act, i) =>
              userData.journey && i < userData.journey.lesson ? (
                <div key={act.slug} className={css.circle}></div>
              ) : (
                <div
                  key={act.slug}
                  className={
                    act.type === "lesson" ? css.circleInactive : css.circleAct
                  }
                ></div>
              )
            )}
          </div>
        </section>

        {userData.member && (
          <section>
            <h1>Cards</h1>
            {terActsList.map((act, i) =>
              userData.journey && i <= userData.journey.lesson ? (
                <div
                  key={act.slug}
                  className={`${css.cardStart} ${css.cardStartActive}`}
                  onClick={() => navigate(`/teract/${act.slug}`)}
                >
                  <i className={`material-icons`}>{act.icon}</i>
                  <h4>{act.title}</h4>
                </div>
              ) : (
                <div key={act.slug} className={`${css.cardStart}`}>
                  <i className={`material-icons`}>{act.icon}</i>
                  <h4>{act.title}</h4>
                </div>
              )
            )}
          </section>
        )}
      </div>
    );
  } else {
    return (
      <div className={css.container}>
        <section>
          <div className={css.schedule}>
            <h2>Agenda {dayjs().format("DD.MM.YY")}</h2>
            <h5>Aqui você visualiza a agenda do seu dia.</h5>
          </div>
        </section>
      </div>
    );
  }
};
